module.exports = __webpack_public_path__ + "static/media/cancel-dark.57a04170.svg";